import React from "react";

const BackgroundSVG: React.FC = () => (
  <div id="bg-wrap" className="absolute inset-0">
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid slice"
      className="w-full h-full"
    >
      <defs>
        <radialGradient
          id="Gradient1"
          cx="50%"
          cy="50%"
          fx="0.441602%"
          fy="50%"
          r=".5"
        >
          <animate
            attributeName="fx"
            dur="34s"
            values="0%;3%;0%"
            repeatCount="indefinite"
          />
          <stop offset="0%" stopColor="#F7E7CE" /> {/* Champagne */}
          <stop offset="50%" stopColor="#F9C74F" /> {/* Vivid Yellow */}
          <stop offset="100%" stopColor="rgba(247, 231, 206, 0)" />
        </radialGradient>
        <radialGradient
          id="Gradient2"
          cx="50%"
          cy="50%"
          fx="2.68147%"
          fy="50%"
          r=".5"
        >
          <animate
            attributeName="fx"
            dur="23.5s"
            values="0%;3%;0%"
            repeatCount="indefinite"
          />
          <stop offset="0%" stopColor="#DCAE96" /> {/* Dusty Rose */}
          <stop offset="50%" stopColor="#F9844A" /> {/* Bright Orange */}
          <stop offset="100%" stopColor="rgba(220, 174, 150, 0)" />
        </radialGradient>
        <radialGradient
          id="Gradient3"
          cx="50%"
          cy="50%"
          fx="0.836536%"
          fy="50%"
          r=".5"
        >
          <animate
            attributeName="fx"
            dur="21.5s"
            values="0%;3%;0%"
            repeatCount="indefinite"
          />
          <stop offset="0%" stopColor="#B2AC88" /> {/* Sage Green */}
          <stop offset="50%" stopColor="#43AA8B" /> {/* Vivid Green */}
          <stop offset="100%" stopColor="rgba(178, 172, 136, 0)" />
        </radialGradient>
        <radialGradient
          id="Gradient4"
          cx="50%"
          cy="50%"
          fx="4.56417%"
          fy="50%"
          r=".5"
        >
          <animate
            attributeName="fx"
            dur="23s"
            values="0%;5%;0%"
            repeatCount="indefinite"
          />
          <stop offset="0%" stopColor="#8E918F" /> {/* Pewter */}
          <stop offset="50%" stopColor="#577590" /> {/* Deep Blue */}
          <stop offset="100%" stopColor="rgba(142, 145, 143, 0)" />
        </radialGradient>
        <radialGradient
          id="Gradient5"
          cx="50%"
          cy="50%"
          fx="2.65405%"
          fy="50%"
          r=".5"
        >
          <animate
            attributeName="fx"
            dur="24.5s"
            values="0%;5%;0%"
            repeatCount="indefinite"
          />
          <stop offset="0%" stopColor="#2C3E50" /> {/* Midnight Blue */}
          <stop offset="50%" stopColor="#277DA1" /> {/* Bright Teal */}
          <stop offset="100%" stopColor="rgba(44, 62, 80, 0)" />
        </radialGradient>
      </defs>
      <rect
        x="13.744%"
        y="1.18473%"
        width="100%"
        height="100%"
        fill="url(#Gradient1)"
        transform="rotate(334.41 50 50)"
      >
        <animate
          attributeName="x"
          dur="20s"
          values="25%;0%;25%"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          dur="21s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur="7s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x="-2.17916%"
        y="35.4267%"
        width="100%"
        height="100%"
        fill="url(#Gradient2)"
        transform="rotate(255.072 50 50)"
      >
        <animate
          attributeName="x"
          dur="23s"
          values="-25%;0%;-25%"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          dur="24s"
          values="0%;50%;0%"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur="12s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x="9.00483%"
        y="14.5733%"
        width="100%"
        height="100%"
        fill="url(#Gradient3)"
        transform="rotate(139.903 50 50)"
      >
        <animate
          attributeName="x"
          dur="25s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          dur="12s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="360 50 50"
          to="0 50 50"
          dur="9s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x="5.244%"
        y="40.5733%"
        width="100%"
        height="100%"
        fill="url(#Gradient4)"
        transform="rotate(360.903 50 50)"
      >
        <animate
          attributeName="x"
          dur="15s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          dur="18s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="360 50 50"
          to="0 50 50"
          dur="8s"
          repeatCount="indefinite"
        />
      </rect>
      <rect
        x="-4.00483%"
        y="24.5733%"
        width="100%"
        height="100%"
        fill="url(#Gradient5)"
        transform="rotate(139.903 50 50)"
      >
        <animate
          attributeName="x"
          dur="30s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          dur="14s"
          values="0%;25%;0%"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 50 50"
          to="360 50 50"
          dur="12s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>

    <div className="absolute inset-0 bg-white opacity-20"></div>
  </div>
);

export default BackgroundSVG;
